import { Modal } from "@/Common/Components/Modals/Modal";
import * as LocalOperations from "@/Common/Operations/operations.local";

interface IEditListNamePopupControlProps {
    CancelClickOperation: number;
    OkClickOperation: number;
    ContainerId: string;
    CurrentListName: string
}

class EditListNamePopupControlState {
    public ListName: string;
}

class EditListNamePopupControl extends React.Component<IEditListNamePopupControlProps, EditListNamePopupControlState> {
    constructor(props: IEditListNamePopupControlProps) {
        super(props);

        const initialState = new EditListNamePopupControlState();
        this.state = initialState;
    }

    public render(): JSX.Element {
        return (
            <Modal
                showOverlay
                showX
                centerContent
                width={550}
                title={cacheStore.GetString("EditWaitingListLabel")}
                onClose={() => this.onClose()}
                footer={(
                    <div className="display-flex-justified-end">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <button
                                    className="btn btn-danger push-right-5"
                                    onClick={() => this.DeleteListClick()}
                                >
                                    {cacheStore.GetString("DeleteWaitingListLabel")}
                                </button>
                                <button
                                    data-action="cancel"
                                    className="btn btn-default push-right-5"
                                    onClick={e => this.onCancelClick(e)}
                                >
                                    {cacheStore.GetString("CancelLabel")}
                                </button>
                                <button
                                    data-action="ok"
                                    className="btn btn-primary"
                                    onClick={e => this.onOkClick(e)}
                                >
                                    {cacheStore.GetString("OKLabel")}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                draggable
            >
                <div className="row">
                    <div className="col-lg-12">
                        <label>
                            {cacheStore.GetString("EditWaitingListMessage")}
                        </label>
                    </div>
                    <div className="col-lg-12">
                        <input
                            className="col-lg-12 form-control"
                            type="text"
                            onChange={e => this.handleChange(e)}
                            id="listName"
                            value={this.state.ListName}
                            defaultValue={this.props.CurrentListName}
                        />
                    </div>
                </div>
            </Modal>
        );
    }

    public componentDidMount(): void {
        var s = new EditListNamePopupControlState();
        s.ListName = this.props.CurrentListName;
        this.setState(s);
    }

    private onOkClick(e: React.MouseEvent): void {
        e.preventDefault();
        sessionStore.dispatch(this.props.OkClickOperation, { value: this.state.ListName });
    }

    private DeleteListClick(): void {
        sessionStore.dispatch(LocalOperations.Lists.DeleteList_ShowPopup);
    }

    private onCancelClick(e: React.MouseEvent): void {
        e.preventDefault();
        this.onClose();
    }

    private onClose(): void {
        sessionStore.dispatch(this.props.CancelClickOperation);
    }

    private handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
        var s = new EditListNamePopupControlState();
        s.ListName = e.target.value;
        this.setState(s);
    }
}

export { EditListNamePopupControl };
